module.exports = __webpack_public_path__ + "static/media/speaker_head_expressions_face_left_up.f0713e5a.png";